<template>
    <header>
        <!-- <div class="left-bar">
            <span><h2>私募之家</h2>|账户</span>
        </div> -->
        <div class="right-bar">
            <template v-if="userId > 0">
                <img :src="avatar" alt="">
                <span>{{userName}}</span>
                <a @click="logout">退出</a>
            </template>
            <template v-else>
                <a @click="login">登录</a>
            </template>
        </div>
    </header>
</template>

<script>
/* eslint-disable no-undef */
export default {
    data () {
        return {
            newstockReverseVisible: false,
            questionVisible: false,
            phoneVisible: false,
            feedbackVisible: false,
            isIntranet: false
        }
    },
    computed: {
        userId () {
            return this.$store.state.userInfo.userId
        },
        userName () {
            return unescape(this.$store.state.userInfo.userName)
        },
        avatar () {
            return this.$store.state.userInfo.avatar
        }
    },
    methods: {
        logout () {
            document.location.href = '//upass.forfunds.cn/logout?redir=' + document.location.href
        },
        login () {
            // ThsLogin.showLoginBox('//' + document.domain + '/developer/pop-login.html')
            window.LoginInstance.show()
        }
    }
}
</script>

<style lang="scss">
header {
    background: #ffffff;
    vertical-align: middle;
    height: 64px;
    line-height: 64px;
    margin-left: 256px;
    padding-right: 60px;
    box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
    position: relative;
    z-index: 2;
    .left-bar {
        padding-left: 10px;
        color: white;
        text-align: left;
        float: left;
        span {
            padding: 10px;
            h2 {
                display: inline-block;
            }
        }
    }
    .right-bar {
        color: rgba(0, 0, 0, 0.65);
        // padding: 20px;
        float: right;
        text-align: right;
        img {
            display: inline-block;
            vertical-align: middle;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 8px;
        }
        a {
            color: #108ee9;
            margin-left: 25px;
            &:hover {
                font-weight: bold;
                cursor: pointer;
            }
        }
    }
    div {
        display: inline-block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue